/* Optimal Experience 1.0 · Sin librerías, píxeles ni escrituras en Shopify. */
(() => {
  'use strict';
  if (window.OptimalExperience) return;
  const KEY = 'optimal.selection.v1', MAX = 12, DAY = 86400000;
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const searchText = value => normalize(value).replace(/[^a-z0-9]/g, '');
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,199}$/.test(value);
  const validId = value => /^\d{1,20}$/.test(String(value || ''));
  const keyOf = row => `${row.handle}:${row.id}`;
  const clean = rows => {
    if (!Array.isArray(rows)) return [];
    const seen = new Set();
    return rows.filter(r => r && validHandle(r.handle) && validId(r.id)).map(r => ({handle:r.handle,id:String(r.id)})).filter(r => {
      if (seen.has(keyOf(r))) return false;
      seen.add(keyOf(r)); return true;
    }).slice(0, MAX);
  };
  const read = () => {
    try {
      const data = JSON.parse(localStorage.getItem(KEY) || 'null');
      return data && Number.isFinite(data.expires) && data.expires > Date.now() ? clean(data.items) : [];
    } catch (_) { return []; }
  };
  let selection = read();
  const commit = rows => {
    selection = clean(rows);
    let persisted = true;
    try {
      if (selection.length) localStorage.setItem(KEY, JSON.stringify({expires:Date.now()+30*DAY,items:selection}));
      else localStorage.removeItem(KEY);
    } catch (_) { persisted = false; }
    window.dispatchEvent(new CustomEvent('opx:selection', {detail:{persisted}}));
    return persisted;
  };
  const has = row => selection.some(item => keyOf(item) === keyOf(row));
  const toggle = row => {
    if (!validHandle(row.handle) || !validId(row.id)) return 'No se pudo guardar esta presentación. Abre su ficha y vuelve a intentarlo.';
    if (has(row)) { commit(selection.filter(item => keyOf(item) !== keyOf(row))); return 'Presentación retirada de tu selección.'; }
    if (selection.length >= MAX) return `Puedes guardar hasta ${MAX} presentaciones. Retira una para añadir otra.`;
    return commit([...selection, row]) ? 'Presentación guardada en este navegador durante 30 días.' : 'Guardado durante esta visita. El navegador no permite conservar la selección al cerrar esta página.';
  };
  window.addEventListener('storage', event => {
    if (event.key !== KEY && event.key !== null) return;
    selection = read(); window.dispatchEvent(new CustomEvent('opx:selection'));
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) { selection=read(); window.dispatchEvent(new CustomEvent('opx:selection')); }
  });
  const el = (tag, cls, text) => {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text !== undefined) node.textContent = String(text);
    return node;
  };
  const rootPath = value => {
    try { const url = new URL(value || '/', location.origin); return url.origin === location.origin ? url.pathname.replace(/\/?$/, '/') : '/'; }
    catch (_) { return '/'; }
  };
  const productPath = (root, p, v) => `${root}products/${encodeURIComponent(p.handle)}${v ? '?variant='+encodeURIComponent(v.id) : ''}`;
  const safeImage = value => {
    if (!value || typeof value !== 'string') return '';
    try { const url = new URL(value, location.origin); return url.protocol === 'https:' ? url.href : ''; }
    catch (_) { return ''; }
  };
  const parseData = node => { try { return JSON.parse(node?.content?.textContent || node?.textContent || 'null'); } catch (_) { return null; } };
  const amount = (value, currency) => {
    if (!Number.isFinite(Number(value))) return 'Consultar precio';
    try { return new Intl.NumberFormat('es-ES',{style:'currency',currency,currencyDisplay:'code'}).format(Number(value)/100); }
    catch (_) { return `${(Number(value)/100).toFixed(2)} ${currency}`; }
  };
  const variantLabel = v => v.title === 'Default Title' ? 'Presentación única' : v.title;
  const announce = (host, text) => { const node = host.querySelector('[data-opx-status]'); if (node) node.textContent = text; };
  const makeButton = (label, cls, callback) => {
    const b = el('button',cls,label); b.type='button'; b.addEventListener('click',callback); return b;
  };
  class Connected extends HTMLElement {
    setup() { this._controller?.abort(); this._controller = new AbortController(); return this._controller.signal; }
    disconnectedCallback() { this._controller?.abort(); }
  }
  class OptimalSelection extends Connected {
    connectedCallback() {
      const signal = this.setup();
      this.root = rootPath(this.dataset.root);
      this.currency = this.dataset.currency || 'EUR';
      this.products = new Map(); this.compare = []; this.limit=9; this._ready=false;
      const data = parseData(this.querySelector('[data-opx-products]'));
      (Array.isArray(data) ? data : []).forEach(p => { if (validHandle(p.handle) && Array.isArray(p.variants)) this.products.set(p.handle,p); });
      this.querySelectorAll('[data-opx-card]').forEach(card => {
        const p = this.products.get(card.dataset.handle);
        if (!p) return;
        card.querySelector('select')?.addEventListener('change',()=>this.updateCard(card,p),{signal});
        card.querySelector('[data-opx-save]')?.addEventListener('click',()=>{
          announce(this,toggle({handle:p.handle,id:card.querySelector('select').value}));
        },{signal});
        card.querySelector('[data-opx-compare]')?.addEventListener('click',()=>{
          const v = p.variants.find(v=>String(v.id)===card.querySelector('select').value);
          if (v) this.toggleCompare(p,v);
        },{signal});
        this.updateCard(card,p);
      });
      this.querySelectorAll('[data-opx-js]').forEach(n=>n.hidden=false);
      this.querySelectorAll('[data-opx-filter]').forEach(node=>node.addEventListener(node.type==='search'?'input':'change',()=>{this.limit=9;this.filter();},{signal}));
      this.querySelector('[data-opx-more]')?.addEventListener('click',()=>{
        const old = this.limit; this.limit+=9; this.filter();
        this._matches?.[old]?.querySelector('a')?.focus({preventScroll:true});
      },{signal});
      this.querySelector('[data-opx-reset]')?.addEventListener('click',()=>{
        this.querySelector('[data-opx-query]').value=''; this.querySelector('[data-opx-type]').value='';
        this.querySelector('[data-opx-sort]').value='title'; this.querySelector('[data-opx-stock]').checked=false;
        this.limit=9; this.filter(); this.querySelector('[data-opx-query]').focus();
      },{signal});
      this.querySelector('[data-opx-clear]')?.addEventListener('click',()=>{commit([]);announce(this,'Se ha vaciado tu selección.');},{signal});
      this.querySelector('[data-opx-retry]')?.addEventListener('click',()=>this.loadSaved(),{signal});
      this.querySelector('[data-opx-compare-clear]')?.addEventListener('click',()=>{this.compare=[];this.renderComparison();this.syncButtons();},{signal});
      window.addEventListener('opx:selection',()=>{this.syncButtons();this.loadSaved();},{signal});
      this.filter(); this.loadSaved(); this.renderComparison();
    }
    updateCard(card,p) {
      const v = p.variants.find(v=>String(v.id)===card.querySelector('select')?.value) || p.variants[0];
      if (!v) return;
      card.dataset.price=String(v.price); card.dataset.available=String(Boolean(v.available));
      card.querySelector('[data-opx-price]').textContent=v.priceText || amount(v.price,this.currency);
      const stock=card.querySelector('[data-opx-availability]'); stock.textContent=v.available?'Disponible':'Agotado';stock.dataset.stock=String(Boolean(v.available));
      card.querySelectorAll('[data-opx-product-link]').forEach(a=>a.href=productPath(this.root,p,v));
      this.syncButtons();
      if (this._ready) this.filter();
    }
    syncButtons() {
      this.querySelectorAll('[data-opx-card]').forEach(card=>{
        const row={handle:card.dataset.handle,id:card.querySelector('select')?.value};
        const saved=has(row), compared=this.compare.some(c=>keyOf(c)===keyOf(row));
        const save=card.querySelector('[data-opx-save]'),compare=card.querySelector('[data-opx-compare]');
        if(save){save.textContent=saved?'Guardado ✓':'Guardar +';save.setAttribute('aria-pressed',String(saved));}
        if(compare){compare.textContent=compared?'Comparando ✓':'Comparar';compare.setAttribute('aria-pressed',String(compared));}
      });
    }
    filter() {
      const query=searchText(this.querySelector('[data-opx-query]').value), type=this.querySelector('[data-opx-type]').value;
      const stock=this.querySelector('[data-opx-stock]').checked, sort=this.querySelector('[data-opx-sort]').value;
      const cards=[...this.querySelectorAll('[data-opx-card]')];
      const matches=cards.filter(c=>(!query||searchText(c.dataset.search).includes(query))&&(!type||c.dataset.type===type)&&(!stock||c.dataset.available==='true'));
      matches.sort(sort==='low'?(a,b)=>Number(a.dataset.price)-Number(b.dataset.price):sort==='high'?(a,b)=>Number(b.dataset.price)-Number(a.dataset.price):(a,b)=>a.dataset.title.localeCompare(b.dataset.title,'es'));
      const grid=this.querySelector('[data-opx-grid]');
      cards.forEach(c=>c.hidden=true); matches.forEach((c,i)=>{c.hidden=i>=this.limit;grid.append(c);});
      this.querySelector('[data-opx-count]').textContent=`${matches.length} referencias · mostrando ${Math.min(matches.length,this.limit)}${this.dataset.paginated==='true'?' en esta página':''}`;
      this.querySelector('[data-opx-no-results]').hidden=matches.length!==0;
      this.querySelector('[data-opx-more]').hidden=matches.length<=this.limit;
      this._matches=matches;this._ready=true;
    }
    async fetchProduct(handle) {
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),8000);
      try {
        const response=await fetch(`${this.root}products/${encodeURIComponent(handle)}.js`,{credentials:'same-origin',signal:controller.signal,headers:{Accept:'application/json'}});
        if(!response.ok)throw new Error('Unavailable');
        const p=await response.json();
        if(p.handle!==handle||!Array.isArray(p.variants))throw new Error('Invalid product');
        return {handle:p.handle,title:p.title,type:p.type||'',image:p.featured_image||'',variants:p.variants.map(v=>({id:String(v.id),title:v.title,sku:v.sku||'',available:Boolean(v.available),price:v.price,priceText:amount(v.price,this.currency)}))};
      } finally {clearTimeout(timer);}
    }
    async loadSaved() {
      const version=(this._loadVersion||0)+1;this._loadVersion=version;
      const rows=selection.slice();
      const missing=[...new Set(rows.filter(r=>!this.products.has(r.handle)).map(r=>r.handle))];
      if(missing.length) this.querySelector('[data-opx-saved-note]').textContent='Actualizando las presentaciones guardadas…';
      // Como máximo 12 referencias; lotes de 3 peticiones para no saturar la tienda.
      for(let i=0;i<missing.length;i+=3){
        const batch=missing.slice(i,i+3);
        const results=await Promise.allSettled(batch.map(h=>this.fetchProduct(h)));
        if(!this.isConnected||version!==this._loadVersion)return;
        results.forEach(r=>{if(r.status==='fulfilled')this.products.set(r.value.handle,r.value);});
      }
      if(!this.isConnected||version!==this._loadVersion)return;
      this.renderSaved();
    }
    renderSaved() {
      const grid=this.querySelector('[data-opx-saved-grid]'),active=document.activeElement?.dataset.opxRestore;
      grid.replaceChildren();let failed=false;
      selection.forEach(row=>{
        const p=this.products.get(row.handle),v=p?.variants.find(v=>String(v.id)===row.id);
        const card=el('article','opx-card'),body=el('div','opx-card-body');
        if(p&&v){
          const media=el('a','opx-card-media');media.href=productPath(this.root,p,v);media.setAttribute('aria-label',`Ver ${p.title}`);
          const url=safeImage(p.image);
          if(url){const img=el('img');img.src=url;img.alt=p.title;img.width=380;img.height=300;img.loading='lazy';media.append(img);}
          else media.append(el('span','opx-card-monogram','OP.'));
          card.append(media);body.append(el('div','opx-ey',p.type||'Colección Optimal'),el('h3','',p.title),el('p','opx-small',variantLabel(v)),el('strong','opx-price',v.priceText||amount(v.price,this.currency)),el('span','opx-small opx-muted',v.available?'Disponible':'Agotado'));
          const actions=el('div','opx-row');
          const link=el('a','opx-btn opx-btn--light','Ver ficha ↗');link.href=productPath(this.root,p,v);actions.append(link);
          const compare=makeButton('Comparar','opx-btn opx-btn--light',()=>this.toggleCompare(p,v));actions.append(compare);body.append(actions);
        } else {
          failed=true;body.append(el('div','opx-ey','Presentación guardada'),el('h3','','No se pudo actualizar'),el('p','opx-small opx-muted',p?'Este formato ya no aparece en la ficha. Revisa las presentaciones actuales.':'Puede que la referencia haya cambiado o que haya un problema de conexión.'));
          const link=el('a','opx-link','Consultar referencia ↗');link.href=productPath(this.root,{handle:row.handle});body.append(link);
        }
        const remove=makeButton('Retirar de mi selección','opx-reset',()=>{
          commit(selection.filter(item=>keyOf(item)!==keyOf(row)));announce(this,'Presentación retirada.');
          this.querySelector('[data-opx-saved-heading]').focus({preventScroll:true});
        });remove.dataset.opxRestore=keyOf(row);body.append(remove);card.append(body);grid.append(card);
      });
      this.querySelector('[data-opx-saved-count]').textContent=String(selection.length);
      this.querySelector('[data-opx-saved-empty]').hidden=selection.length>0;
      this.querySelector('[data-opx-clear]').hidden=selection.length===0;
      this.querySelector('[data-opx-retry]').hidden=!failed;
      this.querySelector('[data-opx-saved-note]').textContent='Hasta 12 presentaciones. Se guardan durante 30 días en este navegador; no se sincronizan con tu cuenta. Puedes borrarlas cuando quieras.';
      if(active)grid.querySelectorAll('[data-opx-restore]').forEach(b=>{if(b.dataset.opxRestore===active)b.focus({preventScroll:true});});
    }
    toggleCompare(p,v) {
      const row={handle:p.handle,id:String(v.id)},index=this.compare.findIndex(c=>keyOf(c)===keyOf(row));
      if(index>=0)this.compare.splice(index,1);
      else if(this.compare.length===3){announce(this,'Puedes comparar tres presentaciones a la vez. Retira una para añadir otra.');return;}
      else this.compare.push(row);
      this.renderComparison();this.syncButtons();
      announce(this,`${this.compare.length} de 3 presentaciones en el comparador, debajo de tu selección.`);
    }
    renderComparison() {
      const table=this.querySelector('[data-opx-table]'),chips=this.querySelector('[data-opx-compare-list]');table.replaceChildren();chips.replaceChildren();
      const entries=this.compare.map(r=>({r,p:this.products.get(r.handle)})).map(e=>({...e,v:e.p?.variants.find(v=>String(v.id)===e.r.id)})).filter(e=>e.p&&e.v);
      const shortcut=this.querySelector('[data-opx-compare-shortcut]');
      if(shortcut){shortcut.hidden=!entries.length;shortcut.textContent=`Ver comparador (${entries.length}/3) ↑`;}
      this.querySelector('[data-opx-compare-empty]').hidden=entries.length>0;
      this.querySelector('[data-opx-table-wrap]').hidden=!entries.length;
      this.querySelector('[data-opx-compare-clear]').hidden=!entries.length;
      if(!entries.length)return;
      const caption=el('caption','opx-sr','Comparación descriptiva de presentaciones');table.append(caption);
      const head=el('thead'),header=el('tr');header.append(el('th','','Referencia'));
      entries.forEach(e=>{const th=el('th','',e.p.title);th.scope='col';header.append(th);});head.append(header);table.append(head);
      const body=el('tbody');
      [['Presentación',e=>variantLabel(e.v)],['Precio',e=>e.v.priceText||amount(e.v.price,this.currency)],['Disponibilidad',e=>e.v.available?'Disponible':'Agotado'],['Categoría',e=>e.p.type||'No indicada'],['SKU',e=>e.v.sku||'No publicado']].forEach(([name,value])=>{
        const tr=el('tr'),th=el('th','',name);th.scope='row';tr.append(th);entries.forEach(e=>tr.append(el('td','',value(e))));body.append(tr);
      });
      const tr=el('tr'),th=el('th','','Ficha');th.scope='row';tr.append(th);entries.forEach(e=>{const td=el('td'),a=el('a','opx-btn opx-btn--light','Ver formato ↗');a.href=productPath(this.root,e.p,e.v);td.append(a);tr.append(td);});body.append(tr);table.append(body);
      entries.forEach(e=>{
        const b=makeButton(`${e.p.title} · ${variantLabel(e.v)} ×`,'opx-chip',()=>{this.toggleCompare(e.p,e.v);this.querySelector('[data-opx-compare-heading]').focus({preventScroll:true});});
        b.setAttribute('aria-label',`Quitar ${e.p.title}, ${variantLabel(e.v)}, de la comparación`);chips.append(b);
      });
    }
  }
  class OptimalDocuments extends Connected {
    connectedCallback() {
      const signal=this.setup(),form=this.querySelector('[data-opx-doc-form]');if(!form)return;
      const lot=this.querySelector('[data-opx-lot]'),product=this.querySelector('[data-opx-doc-product]');
      const params=new URL(location.href).searchParams;lot.value=(params.get('lote')||'').slice(0,120);
      const ref=params.get('referencia')||'';if([...product.options].some(o=>o.value===ref))product.value=ref;
      const update=write=>{
        // Coincidencia exacta de lote: se conservan guiones, signos y espacios interiores.
        const value=lot.value.trim().toLocaleUpperCase('es');let count=0;
        this.querySelectorAll('[data-opx-doc]').forEach(card=>{
          const match=(!value||card.dataset.lot.trim().toLocaleUpperCase('es')===value)&&(!product.value||card.dataset.product===product.value);
          card.hidden=!match;if(match)count++;
        });
        this.querySelector('[data-opx-doc-empty]').hidden=count>0;
        this.querySelector('[data-opx-doc-count]').textContent=value?`${count} documento${count===1?'':'s'} para el lote indicado`:`${count} documento${count===1?'':'s'} publicados`;
        if(write){const url=new URL(location.href);[['lote',lot.value.trim()],['referencia',product.value]].forEach(([k,v])=>v?url.searchParams.set(k,v):url.searchParams.delete(k));history.replaceState(history.state,'',url);}
      };
      form.addEventListener('submit',event=>{event.preventDefault();update(true);},{signal});
      product.addEventListener('change',()=>update(true),{signal});
      this.querySelector('[data-opx-doc-reset]')?.addEventListener('click',()=>{lot.value='';product.value='';update(true);lot.focus();},{signal});
      this.querySelectorAll('[data-opx-copy-lot]').forEach(button=>button.addEventListener('click',async()=>{
        const card=button.closest('[data-opx-doc]'),url=new URL(location.href);url.search='';url.hash='';url.searchParams.set('lote',card.dataset.lot);url.searchParams.set('referencia',card.dataset.product);
        try{await navigator.clipboard.writeText(url.href);announce(this,'Enlace del lote copiado.');}
        catch(_){const fallback=this.querySelector('[data-opx-copy-fallback]');fallback.hidden=false;fallback.value=url.href;fallback.focus();fallback.select();announce(this,'Selecciona y copia el enlace que aparece debajo.');}
      },{signal}));
      this.querySelectorAll('[data-opx-js]').forEach(n=>n.hidden=false);update(false);
    }
  }
  class OptimalTools extends Connected {
    connectedCallback() {
      const signal=this.setup(),p=parseData(this.querySelector('[data-opx-product]'));if(!p?.handle)return;
      const save=this.querySelector('[data-opx-save-product]');if(!save)return;
      const scope=this.closest('optimal-product')||this.closest('.shopify-section')||document;
      const getVariant=()=>{
        const selector=scope.querySelector('[data-variant]');
        const fromUrl=new URL(location.href).searchParams.get('variant');
        const id=selector?.value||fromUrl||p.selected;
        return p.variants.find(v=>String(v.id)===String(id));
      };
      const sync=()=>{
        const v=getVariant();save.disabled=!v;
        const saved=Boolean(v&&has({handle:p.handle,id:String(v.id)}));
        save.textContent=saved?'Presentación guardada ✓':'Guardar presentación +';save.setAttribute('aria-pressed',String(saved));
      };
      save.addEventListener('click',()=>{const v=getVariant();if(v)announce(this,toggle({handle:p.handle,id:String(v.id)}));sync();},{signal});
      scope.addEventListener('change',sync,{signal});window.addEventListener('opx:selection',sync,{signal});window.addEventListener('popstate',sync,{signal});
      save.hidden=false;sync();
    }
  }
  class OptimalUniverse extends Connected {
    connectedCallback() {
      const signal=this.setup(),button=this.querySelector('[data-opx-motion]');if(!button)return;
      button.hidden=false;const reduced=window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      if(reduced){this.dataset.paused='true';button.hidden=true;return;}
      button.addEventListener('click',()=>{const pause=this.dataset.paused!=='true';this.dataset.paused=String(pause);button.textContent=pause?'Reanudar movimiento':'Pausar movimiento';button.setAttribute('aria-pressed',String(pause));},{signal});
    }
  }
  window.OptimalExperience={version:'1.0.0'};
  [['opx-selection',OptimalSelection],['opx-documents',OptimalDocuments],['opx-tools',OptimalTools],['opx-universe',OptimalUniverse]].forEach(([name,constructor])=>{if(!customElements.get(name))customElements.define(name,constructor);});
})();
